<template>
  <div class="back-to-top" :style="{transform: 'scale('+ itemScale +')'}">
    <a href="javascript:scroll(0,0)">
      <i class="bi bi-rocket-takeoff"></i>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    itemScale: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style>
  .back-to-top{
    position: fixed;
    bottom: 40px;
    right: 40px;
    z-index: 99;
    border: 0;
    outline: 0;
    padding: 0;
    transition: all 0.8s ease !important;
  }
  .back-to-top a {
    color: #505050;
    font-size: 28px;
    transition: all 0.4s ease !important;
  }
  .back-to-top a:hover {
    font-size: 30px;
    color: #fd8d3c;
  }
</style>